import React from 'react';

export default function Roadmap() {
  return (
    <section className="w-full bg-black text-white py-20 px-6 md:px-10">
      <div className="max-w-5xl mx-auto space-y-14">

        {/* Section Header */}
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Roadmap</h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            We’re focused on rapid but strategic execution — starting lean, shipping smart, and scaling sustainably.
          </p>
        </div>

        {/* Timeline */}
        <div className="space-y-10">

          {/* Phase 1 */}
          <div className="bg-gray-900 border-l-4 border-purple-600 p-6 rounded-lg shadow">
            <h3 className="text-xl font-semibold mb-1 text-white">🚀 0–3 Months: MVP & Pilot Launch</h3>
            <ul className="text-gray-400 list-disc list-inside space-y-1 text-sm">
              <li>Launch SmartCard login + role dashboard (React + Firebase)</li>
              <li>Onboard first 200 users via invite-only waitlist</li>
              <li>Release investor deck, raise pre-seed capital ($150–250k)</li>
              <li>Secure core legal (Dubai + India) and compliance advisors</li>
            </ul>
          </div>

          {/* Phase 2 */}
          <div className="bg-gray-900 border-l-4 border-yellow-500 p-6 rounded-lg shadow">
            <h3 className="text-xl font-semibold mb-1 text-white">🌍 3–6 Months: Expansion & Revenue Onboarding</h3>
            <ul className="text-gray-400 list-disc list-inside space-y-1 text-sm">
              <li>Launch monetization for 4–5 core roles (educators, mentors, brokers, signal providers)</li>
              <li>Activate job board + marketplace with 100 live role listings</li>
              <li>Grow early MRR via role-based SaaS and services</li>
              <li>Begin outreach to micro-VCs, accelerators, and global advisors</li>
            </ul>
          </div>

          {/* Phase 3 */}
          <div className="bg-gray-900 border-l-4 border-green-500 p-6 rounded-lg shadow">
            <h3 className="text-xl font-semibold mb-1 text-white">💼 6–12 Months: Scale & Seed Readiness</h3>
            <ul className="text-gray-400 list-disc list-inside space-y-1 text-sm">
              <li>Reach $10k–$25k MRR across verified role verticals</li>
              <li>Form partnerships with trading schools, fintech tools, investor zones</li>
              <li>Release public dashboard + analytics for investors</li>
              <li>Raise seed round to scale across 24 countries</li>
            </ul>
          </div>

        </div>

      </div>
    </section>
  );
}
